import { QUERY_KEYS } from "@cnx/common";
import { useQuery } from "@tanstack/react-query";
import ExtraShipmentService from "services/ExtraShipmentService";

export const useUnclearShipmentsCount = ({
  terminalId,
}: {
  terminalId: string | null;
}) => {
  const { data } = useQuery({
    queryKey: [
      QUERY_KEYS.TERMINAL_ACTIVITIES,
      { terminalId, type: "unclear-count" },
    ],
    queryFn: () =>
      ExtraShipmentService.getUnclearShipmentsCount({ terminalId }),
  });
  return data ?? 0;
};
